import { render, staticRenderFns } from "./customFilterRoom.vue?vue&type=template&id=523abbfa&scoped=true&"
import script from "./customFilterRoom.vue?vue&type=script&lang=js&"
export * from "./customFilterRoom.vue?vue&type=script&lang=js&"
import style0 from "./customFilterRoom.vue?vue&type=style&index=0&id=523abbfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523abbfa",
  null
  
)

export default component.exports